export default __webpack_public_path__ + "static/media/userStory.d568321d.png";